import { delay, put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import * as CompanyActions from '../Company/actions';
import * as UserActions from '../User/actions';
import toastr from '../../helpers/toastr';
import I18njs from 'i18n-js';
import { selectToken } from '../selectors';

export function* intacctLoginRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/intacct/setup`,
      method: 'POST',
      data: payload.data,
      token: selectToken(store.getState()),
      dontCheckForUnauthorized: true,
    });
    yield put(actions.intacctLoginRequestSuccess(res));
    yield put(CompanyActions.getCompanyRequest());
    toastr.success(I18njs.t('settings.advanced.IntacctCredentialsUpdated'));
  } catch (error) {
    yield put(actions.intacctLoginRequestFailure(error));
  }
}

export function* intacctSyncRequestSaga() {
  try {
    const res = yield send({
      url: `/intacct/run-sync`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.intacctSyncRequestSuccess(res));
  } catch (error) {
    yield put(actions.intacctSyncRequestFailure(error));
  }
}

export function* getSyncStatusRequestSaga(payload) {
  try {
    let attempts = 0;
    let prevValue;
    const res = yield send({
      url: `/intacct/sync-status/${payload.data}`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getSyncStatusRequestSuccess(res));
    if (res.progress !== 100) {
      if (res.progress === prevValue) {
        attempts += 1;
      } else {
        prevValue = res.progress;
      }
      if (attempts < 40) {
        yield delay(3000);
        yield put(actions.getSyncStatusRequest(store.getState().intacct.jobId));
      } else {
        throw new Error('Job inactive for too long');
      }
    } else {
      yield put(CompanyActions.getCompanyRequest());
      yield put(UserActions.getUserRequest());
    }
  } catch (error) {
    yield put(actions.getSyncStatusRequestFailure(error));
  }
}

export function* getCompanySyncStatusRequestSaga() {
  try {
    const res = yield send({
      url: `/intacct/sync-status`,
      method: 'GET',
      token: selectToken(store.getState()),
      skipToast: true,
    });
    yield put(actions.getCompanySyncStatusRequestSuccess(res));
  } catch (error) {
    yield put(actions.getCompanySyncStatusRequestFailure(error));
  }
}
